// lib/formatDate.ts

/**
 * Formats a date into "9th August 2024" style with proper ordinal suffix
 * @param dateInput - Date object, ISO string, or any valid date string
 * @param fallback - Optional fallback string if date is invalid or missing
 * @returns Formatted date string like "9th August 2024"
 */
export function formatDateWithOrdinal(
  dateInput: string | Date | null | undefined,
  fallback: string = "09th Aug. 2024",
): string {
  if (!dateInput) return fallback;

  const date = new Date(dateInput);

  // Check if date is valid
  if (isNaN(date.getTime())) return fallback;

  const day = date.getDate();
  const month = date.toLocaleString("en-GB", { month: "long" });
  const year = date.getFullYear();

  // Determine ordinal suffix
  const suffix =
    day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
        ? "nd"
        : day % 10 === 3 && day !== 13
          ? "rd"
          : "th";

  return `${day}${suffix} ${month} ${year}`;
}
